// extracted by mini-css-extract-plugin
export default {"root":"Divider_root__9OhZz","vertical":"Divider_vertical__QYrHi","horizontal":"Divider_horizontal__s3jCq"};